import * as React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Title } from 'react-admin';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Typography from '@mui/material/Typography';
import { useParams } from 'react-router-dom';
import GetEditPassword from './GetEditPassword';

function ResetPasswordPage() {

    const { hash } = useParams();

    return (
        <Card sx={{ mt: 10, textAlign: 'center', backgroundColor: '#f3f6f9' }}>
            <Title title="Pagina per reset password" />

            <CardContent>
                <ErrorOutlineIcon sx={{ fontSize: 60, color: 'e85a2c' }} />
                <Typography variant="h4" sx={{ margin: '20px 0', color: '#e85a2c' }}>
                    SW KI FACTOR - Reset password
                </Typography>
                <Typography variant="subtitle1">
                    <hr></hr>
                </Typography>
                {<GetEditPassword hash={hash} />}

            </CardContent>
        </Card>
    );
}

export default ResetPasswordPage;
